<script setup lang="ts">
import { useStore } from '~/composables/store'

const props = defineProps<{
  filter?: any
}>()
defineEmits(['remove'])

const data = ref(props.filter?.values.length ? props.filter?.values : [])
const loading = ref(false)

// Function to get the current channel ID
async function getCurrentChannelId() {
  // Try to get from the filter's where function if available
  if (props.filter.item.where) {
    try {
      const whereResult = await props.filter.item.where({})
      if (whereResult?.channelId) {
        return whereResult.channelId
      }
    } catch (e) {
      console.error('Error getting channelId from where function:', e)
    }
  }

  // If not available, use the store's first channel
  const store = useStore()
  return store.channels?.at(0)?.id
}

if (
  data.value?.length &&
  typeof data.value[0] === 'string' &&
  props.filter.item.initialOptions
) {
  loading.value = true

  // Get the channelId
  const channelId = await getCurrentChannelId()

  // Call initialOptions with the channelId
  data.value = await props.filter.item.initialOptions(props.filter.values, {
    channelId,
  })
  loading.value = false
}
const label = computed(() => {
  if (props.filter.item.currency) {
    return (+data.value / 100).toFixed(2)
  }
  if (Array.isArray(data.value)) {
    const v = data.value
      ?.map((v) => (typeof v === 'object' ? v.label : v))
      .join(',')

    // Handle data for compact products
    if (props?.filter?.item?.view === 'product-compact') {
      try {
        // Check if v is a valid string for parsing
        if (!v || typeof v !== 'string' || v.trim() === '') {
          return 'No product selected'
        }

        const parsed = JSON.parse(v)
        return parsed
          ? `(${parsed.productNumber}) ${parsed?.defaultText?.name}`
          : v
      } catch (e) {
        console.error('Error parsing product data:', e, 'Value:', v)
        return 'Product data error'
      }
    }
    // Return usual array presentation
    return v
  } else {
    return data.value
  }
})
</script>
<template>
  <Button
    v-if="filter"
    :key="filter.name"
    class="relative pr-8"
    :loading="loading"
  >
    <span>
      {{ filter.item.label }}
    </span>
    <span class="text-gray-400 px-0.5">{{ filter.operation }}</span>
    <span v-if="label">
      {{ label }}
    </span>
    <div
      class="absolute right-2 p-0.5 text-gray-400 hover:text-gray-800 hover:bg-gray-200 rounded"
      @click="() => $emit('remove')"
    >
      <div class="i-heroicons-solid-x" />
    </div>
  </Button>
</template>
